import { TURKISH_LANGUAGE } from 'constants/features';
import { useFeatureFlags } from 'hooks/useFeatureFlags/useFeatureFlags';
import type { SupportedLocalesKeys } from 'utils/translations/translations';
import { localeCodes, TURKISH_LOCALE } from 'utils/translations/translations';

export function useLocales(): SupportedLocalesKeys[] {
  const isTurkishLanguageEnabled = useFeatureFlags(TURKISH_LANGUAGE);

  if (!isTurkishLanguageEnabled) {
    return localeCodes.filter(
      locale => locale !== TURKISH_LOCALE,
    ) as SupportedLocalesKeys[];
  }

  return localeCodes as SupportedLocalesKeys[];
}
